import { ReactNode } from 'react'

import { Stack, Text } from '@mantine/core'

import { FilterOptions } from '#components/FilterPicker'
import { NavAnchor } from '#components/NavAnchor'
import { OutsideAnchor } from '#components/OutsideAnchor'
import { CHANGE_TRACKING_HELP_URL } from '#util'

const cta: Record<'enabler' | 'admin' | 'plebe', ReactNode> = {
  enabler: (
    <Text>
      To get started, turn on&thinsp;
      <Text fw="bold" span>
        Change-tracking mode&thinsp;
      </Text>
      at the bottom of this panel.
    </Text>
  ),
  admin: (
    <Text>
      To get started, ask someone with&thinsp;
      <NavAnchor href="/settings/org/permissions">permission</NavAnchor>
      &thinsp;to turn on&thinsp;
      <Text fw="bold" span>
        Change-tracking mode&thinsp;
      </Text>
      at the bottom of this panel.
    </Text>
  ),
  plebe: (
    <Text>
      To get started, ask someone with permission to turn on&thinsp;
      <Text fw="bold" span>
        Change-tracking mode&thinsp;
      </Text>
      at the bottom of this panel.
    </Text>
  ),
}

export const ChangeTrackingPlaceholder = ({
  filter,
  canEnable,
  enabled,
  isAdmin,
  revisionsActive,
}: {
  filter: FilterOptions
  canEnable: boolean
  enabled: boolean
  isAdmin: boolean
  revisionsActive?: boolean
}) => {
  const messaging = canEnable ? 'enabler' : isAdmin ? 'admin' : 'plebe'
  const callToAction = enabled ? null : cta[messaging]

  return (
    <Stack p={20}>
      {revisionsActive && (
        <>
          <Text fw="bold">Change-tracking disabled</Text>
          <Text>
            Change-tracking can&apos;t be activated because{' '}
            <Text fw="bold" span>
              Revision Mode
            </Text>{' '}
            has been enabled.
          </Text>
          <Text>
            To track changes on this script, create a duplicate from the
            document pane.
          </Text>
          <OutsideAnchor href={CHANGE_TRACKING_HELP_URL}>
            Learn more.
          </OutsideAnchor>
        </>
      )}
      {!revisionsActive && (
        <>
          <Text fw="bold">
            No {filter === 'open' ? 'proposed' : 'resolved'} changes yet
          </Text>
          <Text>
            Change-tracking mode treats edits to the script as proposed changes
            that will need to be approved or declined.
          </Text>
          {callToAction}
          <OutsideAnchor href={CHANGE_TRACKING_HELP_URL}>
            Learn more.
          </OutsideAnchor>
        </>
      )}
    </Stack>
  )
}
